import type { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useOptionalSession } from 'src/contexts/SessionContext';
import { isEmailMarketingEnabled } from 'src/shared/usePermissionCheck';

export const EmailMarketingRoute: FC = () => {
  const { session } = useOptionalSession();

  return isEmailMarketingEnabled(session) ? (
    <Outlet />
  ) : (
    <Navigate replace to="/emails" />
  );
};
